import React from 'react';
import loadingGif from '../imgs/8s-205px-205px-unscreen.gif';
import logosmall from '../imgs/logonewsmall.png';

const Loading = () => {
  return (
    <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center bg-black bg-opacity-80 z-[9999]">
      {/* Logo or decorative icon */}
      <img 
        src={logosmall}
        alt="Logo" 
        className="h-[120px] w-auto animate-pulse mb-4 drop-shadow-lg"
      />

      {/* Loading text */}
      <h2 className="text-white text-xl font-sansation mb-4 animate-fadeIn">
        Mnd is Loading...
      </h2>

      {/* Spinner */}
      <img 
        src={loadingGif} 
        alt="Loading spinner" 
        className="w-24 h-24 animate-spin-slow"
      />
    </div>
  );
};

export default Loading;
